module.exports = require("repl");


//////////////////
// WEBPACK FOOTER
// external "repl"
// module id = 2807
// module chunks = 0 1